import React, { FC } from 'react';
import { ThemeProvider } from '@emotion/react'
import theme from './assets/theme'
import Router from './router';
import { UserContextProvider } from './contexts/user';
import { PopupNotificationProvider } from './contexts/popup_notification';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const App: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <PopupNotificationProvider>
          <UserContextProvider>
            <Router />
          </UserContextProvider>
        </PopupNotificationProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App
